module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('help'), _vm._v(" "), (_vm.canSeeSupport) ? _c('support') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b69fee2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help.vue
// module id = 2094
// module chunks = 2